import { Component } from '@angular/core';
import { NavController, NavParams, Platform } from '@ionic/angular';

import { InitConstant, DialogConstant } from '../../Constant';

import { AuthService } from '../../service/auth.service';
import { EventService } from '../../service/event.service';

@Component({
    selector: 'app-trashmenu-modal',
    templateUrl: './trashmenu-modal.page.html',
    styleUrls: ['./trashmenu-modal.page.scss'],
})
export class TrashmenuModalPage
{
    private obj: any;
    private file: any;
    private list_viewtype = 'list-block';

    constructor(
        private nav: NavController,
        private navParams: NavParams,
        private platform: Platform,
        private auth: AuthService,
        private event: EventService
    )
    {
    }

    async ngOnInit()
    {
        this.event.modal_subject.next({key: "modalSubscribe", id: 'trashmenu-modal', value: null});
        this.obj = this.navParams.data.obj;
        this.file = this.navParams.data.file;
        this.list_viewtype = this.navParams.data.list_viewtype;
    }

    async fileMenuClose()
    {
        this.event.modal_subject.next({key: "closeModal", id: 'trashmenu-modal', value: null});
        await new Promise(resolve => setTimeout(resolve, 300));
    }
}
